/** =========================================================
 * Module: item-add-button.directive.js
 * Add item button
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.components')
    .directive('itemAddButton', itemAddButton);

  itemAddButton.$inject = ['$rootScope'];

  function itemAddButton($rootScope) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/components/item-add-button.html',
      link: function ($scope) {
        var action = 'add';

        $scope.enabled = false;

        function checkEnabled() {
          if (typeof $scope.config[action].permission !== 'undefined') {
            return $scope.config[action].permission;
          }

          return $rootScope.helpers.hasPermissionTo($scope.config.model + ' ' + action);
        }

        if ($scope.config && $scope.config.model && $scope.config[action]) {
          $scope.enabled = checkEnabled();
        }
      },
      scope: {
        config: '=',
        template: '@?'
      }
    };

    return directive;
  }
})();
